module.exports = __webpack_public_path__ + "media/images/press_kit/test/main-1ef4821cce2c74bce2ef4d69c0314a92.png";